export const NAME_DEFAULT = 'city';
